import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main_login flexEnd" }
const _hoisted_2 = { class: "login_right flexCenter" }
const _hoisted_3 = { style: {"width":"90%"} }
const _hoisted_4 = { style: {"margin":"0 40% 0 80px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header_one" }, "欢迎登录"),
  /*#__PURE__*/_createElementVNode("div", { class: "header_two" }, "管理系统")
], -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("登 录")

import { reactive,ref,onMounted } from 'vue'
	import { requestLogin,requestDDlogin } from '@/api/api'
	import { ElMessage } from 'element-plus'
	import { useRouter } from 'vue-router'
	import * as dd from "dingtalk-jsapi";

	interface resType{
		status:number
		datalist:[]
		msg:string
	}
	interface loginForm {
		user:string
		pwd:string
	}
	
export default /*#__PURE__*/_defineComponent({
  name: 'Login',
  setup(__props) {

	const router = useRouter()
	const form = reactive<loginForm>({
		user:'',
		pwd:''
	})
	onMounted(()=>{
			dd.ready(function() {
                dd.runtime.permission.requestAuthCode({
                    corpId: "ding0909326408a3cb41bc961a6cb783455b",
                    onSuccess: function(result) {
                      	requestDDlogin({
							code:result.code
						}).then((res:resType)=>{
							if(res.status === 1){
								ElMessage({
									message: '登录成功',
									type: 'success',
									duration:300
								})
								setTimeout(()=>{
									router.push({path:'/work'})
								},300)
							}else{
								ElMessage.error(res.msg);
							}
						})
                    },
                    onFail : function(err) {
                        alert(JSON.stringify(err));
                    }
                });
            });
	})
	const login = () =>{
		if(form.user === ""){
			ElMessage({
				message: '请输入用户名',
				type: 'error',
				duration:500
			})
			return
		}
		if(form.pwd === ""){
			ElMessage({
				message: '请输入密码',
				type: 'error',
				duration:500
			})
			return
		}
		requestLogin({
			username:form.user,
			password:form.pwd
		}).then((res:resType)=>{
			console.log(res);
			if(res.status === 1){
				ElMessage({
					message: '登录成功',
					type: 'success',
					duration:300
				})
				setTimeout(()=>{
					router.push({path:'/projectreport'})
				},300)
			}else{
				ElMessage.error(res.msg);
			}
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              size: "large",
              placeholder: "账号",
              modelValue: form.user,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.user) = $event)),
              clearable: "",
              onKeyup: _withKeys(login, ["enter","native"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _hoisted_7,
            _createVNode(_component_el_input, {
              size: "large",
              placeholder: "密码",
              modelValue: form.pwd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.pwd) = $event)),
              "show-password": "",
              onKeyup: _withKeys(login, ["enter","native"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "large",
              placeholder: "秘钥",
              modelValue: form.pwd2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.pwd2) = $event)),
              "show-password": "",
              onKeyup: _withKeys(login, ["enter","native"])
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _createVNode(_component_el_button, {
            round: "",
            type: "primary",
            size: "large",
            class: "footer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (login()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})